module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "pdfwatermark"
    },
    slot: "pdfwatermark"
  }, [_c('div', {
    staticClass: "layui-form-item",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "wm-label"
  }, [_vm._v("拖拽 PDF 到下方区域或点击上传")]), _vm._v(" "), _c('v-upload', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "beforeShow": true,
      "uploadApi": '/static/data/editorUpload.json',
      "accept": ".pdf"
    },
    on: {
      "before": _vm.onUploadPdf
    }
  }, [_c('v-button', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_vm._v("选择 PDF")])], 1), _vm._v(" "), (_vm.pdfBytes && _vm.processedPdfUrl) ? _c('v-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_vm._v("下载水印 PDF")]) : _vm._e(), _vm._v(" "), (_vm.pdfBytes) ? _c('v-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "disabled": !_vm.watermarkText || _vm.processing
    },
    on: {
      "click": _vm.processWatermark
    }
  }, [(_vm.processing) ? _c('span', [_vm._v("处理中...")]) : _c('span', [_vm._v("应用水印")])]) : _vm._e()], 1), _vm._v(" "), (_vm.pdfBytes) ? _c('div', {
    staticClass: "layui-form-item",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "38px",
      "color": "#1aa094"
    }
  }, [_vm._v("已加载 " + _vm._s(_vm.pageCount) + " 页 PDF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wm-controls"
  }, [_c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("文字")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watermarkText),
      expression: "watermarkText"
    }],
    staticClass: "layui-input",
    staticStyle: {
      "width": "160px",
      "display": "inline-block"
    },
    attrs: {
      "placeholder": "水印文字"
    },
    domProps: {
      "value": (_vm.watermarkText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.watermarkText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("模式")]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "width": "90px",
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.modeOptions
    },
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("字号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fontSize),
      expression: "fontSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "layui-input",
    staticStyle: {
      "width": "70px",
      "display": "inline-block"
    },
    attrs: {
      "type": "number",
      "min": "8",
      "max": "600"
    },
    domProps: {
      "value": (_vm.fontSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fontSize = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wm-unit"
  }, [_vm._v("px")])]), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("透明")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.opacity),
      expression: "opacity",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "width": "80px",
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "range",
      "min": "5",
      "max": "100"
    },
    domProps: {
      "value": (_vm.opacity)
    },
    on: {
      "__r": function($event) {
        _vm.opacity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "line-height": "38px",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.opacity) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("颜色")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticStyle: {
      "width": "34px",
      "height": "34px",
      "display": "inline-block",
      "vertical-align": "middle",
      "border": "none",
      "cursor": "pointer",
      "padding": "0"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.color = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "drop-zone",
    class: {
      'drop-zone-active': _vm.dragOver
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDropPdf($event)
      }
    }
  }, [(_vm.processedPdfUrl) ? _c('iframe', {
    staticClass: "pdf-preview",
    attrs: {
      "src": _vm.processedPdfUrl
    }
  }) : (_vm.pdfBytes) ? _c('div', {
    staticClass: "drop-placeholder",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("PDF 已加载，点击「应用水印」预览效果")]) : _c('div', {
    staticClass: "drop-placeholder"
  }, [_vm._v("拖拽 PDF 文件到此处")])]) : _c('div', {
    staticClass: "wm-preview-wrap"
  }, [(_vm.processedPdfUrl) ? _c('iframe', {
    staticClass: "pdf-preview-m",
    attrs: {
      "src": _vm.processedPdfUrl
    }
  }) : (_vm.pdfBytes) ? _c('div', {
    staticClass: "wm-mobile-hint"
  }, [_vm._v("PDF 已加载，点击「应用水印」预览效果")]) : _c('div', {
    staticClass: "wm-mobile-hint"
  }, [_vm._v("点击上方「选择 PDF」上传文件")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8adf3500!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pdfwatermark.vue
// module id = 604
// module chunks = 2